import { tEngine } from "../../../i18n/engine";
import { t } from "../../../i18n";
import { CASE_LABEL, fmt, type CaseId, type WallResult } from "@tasduvar/engine";
import { Section } from "./common";

export function Forces({ result }: { result: WallResult }): JSX.Element {
  const cases = Object.keys(result.cases) as CaseId[];
  return (
    <Section id="forces" title={t("7. Yük Tablosu")}>
      <p className="muted">{t("Kollar burun (0; 0) noktasına göre. V aşağı (+), H devirici yönde (+). Mr = V·x (V > 0), Mo = H·y + |V|·x (V < 0).")}</p>
      {cases.map((cid) => { const c = result.cases[cid]!; return (
        <div key={cid}>
          <h3>{tEngine(CASE_LABEL[cid])}{cid !== "static" ? ` — kh = ${fmt(c.kh, 4)}, kv = ${fmt(c.kv, 4)}` : ""}</h3>
          <table>
            <thead><tr><th>{t("Kuvvet")}</th><th className="num">{t("V (kN/m)")}</th><th className="num">{t("H (kN/m)")}</th><th className="num">x (m)</th><th className="num">y (m)</th><th className="num">{t("Mr (kNm/m)")}</th><th className="num">{t("Mo (kNm/m)")}</th></tr></thead>
            <tbody>
              {c.forces.map((f) => <tr key={f.id}><td>{f.id} · {tEngine(f.label)}</td><td className="num">{fmt(f.V)}</td><td className="num">{fmt(f.H)}</td><td className="num">{fmt(f.armX, 3)}</td><td className="num">{fmt(f.armY, 3)}</td><td className="num">{fmt(f.Mres)}</td><td className="num">{fmt(f.Movr)}</td></tr>)}
              <tr><th>Σ</th><th className="num">{fmt(c.sums.V)}</th><th className="num">{fmt(c.sums.Hdrive)}</th><th /><th /><th className="num">{fmt(c.sums.Mres)}</th><th className="num">{fmt(c.sums.Movr)}</th></tr>
              <tr><td colSpan={7} className="muted">{t("U (kaldırma) =")} {fmt(c.sums.U)} {t("kN/m · N = ΣV − U =")} {fmt(c.sums.N)} {t("kN/m · Direnç ΣHr =")} {fmt(c.sums.Hresist)} {t("kN/m")}{c.sums.Rpk > 0 ? ` · Pasif Rpk = ${fmt(c.sums.Rpk)} kN/m` : ""}</td></tr>
            </tbody>
          </table>
        </div>
      ); })}
    </Section>
  );
}
